import { Box } from "@mui/material";
import { useState } from "react";
import { ReactComponent as AssetThumbnailPlaceholder } from "../../common/assets/img/vectors/asset-thumbnail-placeholder-lg.svg";
import { useTheme } from "../../common/contexts/ThemeContext";
import { resolveImageUrl } from "../../common/utils/imageUrl";

const AssetThumbnail = ({ asset }) => {
  const [imageError, setImageError] = useState(false);
  const { colors } = useTheme();

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: { xs: 150, md: 250 },
        maxWidth: 450,
        position: "relative",
        overflow: "hidden",
        mb: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {asset?.thumbnail && !imageError ? (
        <img
          src={resolveImageUrl(asset.thumbnail)}
          alt={asset?.title || "Asset cover"}
          onError={handleImageError}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <AssetThumbnailPlaceholder
          style={{
            width: "200px",
            height: "200px",
            opacity: 0.5,
            fill: colors.secondary,
          }}
        />
      )}

      {/* Gradient overlay for better text readability */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: "50%",
          background: "linear-gradient(transparent, rgba(0,0,0,0.3))",
          pointerEvents: "none",
        }}
      />
    </Box>
  );
};

export default AssetThumbnail;
